import { routes as datacatalogRoutes } from 'modules/datacatalog';

export const HOME_PAGE_URL = '/home';
export const BUDGET_HOME_PAGE_URL = '/budget_home';
export const BUDGET_OVERVIEW = '/budget_overview';
export const HR_BASE_PATH_URL = '/human_resources';
export const SUPPORT_PAGE_URL = '/support';
export const CHARTS_TEMPLATES_PATHNAME = '/charts_templates';
export const SUPPORT_SEARCH_PATHNAME = '/support_search';
export const AI_QUERY_BUILDER_PATHNAME = '/ai_query_builder';
export const MAINTENANCE_PAGE_URL = '/maintenance';
export const DASHBOARDS_PAGE_URL = '/dashboards';
export const DECISION_ADMIN_PAGE_URL = '/decision_admin';
export const PROJECTIONS_PAGE_URL = '/projections';
export const DECISION_CTA_PAGE_URL = '/decision_cta';
export const DECISION_NO_ACCESS_PAGE_URL = '/decision_no_access';
export const BUDGET_CTA_PAGE_URL = '/budget_cta';
export const BUDGET_NO_ACCESS_PAGE_URL = '/budget_no_access';
export const HR_CTA_PAGE_URL = '/human_resources/cta';
export const HR_NO_ACCESS_PAGE_URL = '/human_resources/no_access';
export const PROJECTIONS_NO_ACCESS_PAGE_URL = '/projections_no_access';

const routes = {
    activateAccount: '/activate_account/:token',
    resetPassword: '/reset_password/:token',
    maintenancePage: MAINTENANCE_PAGE_URL,
    supportBindTab: '/support/:bind/:tab',
    supportBind: '/support/:bind',
    support: SUPPORT_PAGE_URL,
    chartsTemplates: CHARTS_TEMPLATES_PATHNAME,
    supportSearch: SUPPORT_SEARCH_PATHNAME,
    supportSearchTab: `${SUPPORT_SEARCH_PATHNAME}/:tab`,
    aiQueryBuilder: AI_QUERY_BUILDER_PATHNAME,
    explore: '/explore',
    exploreChart: '/explore/:chartKey',
    integrations: '/integrations',
    profile: '/profile',
    adminTab: '/admin/:tab',
    adminBudget: '/budget_admin/:tab',
    initialisationBudget: '/budget_admin/initialisation/:initialisationId',
    argumentDuplicationBudget:
        '/budget_admin/argument_duplication/:duplicationId',
    mappings: '/mappings',
    decisionCta: '/decision_cta',
    decisionNoAccess: DECISION_NO_ACCESS_PAGE_URL,
    dashboard: '/dashboard/:slug',
    dashboardPdf: '/dashboard/:slug/pdf',
    publicDashboard: '/public/dashboard/:slug',
    budgetCta: BUDGET_CTA_PAGE_URL,
    budgetNoAccess: BUDGET_NO_ACCESS_PAGE_URL,
    budgetProposal: '/budget_proposal/:budgetProposalId',
    budgetProposalByResource:
        '/budget_proposal/:budgetProposalId/resource/:resourceSoftwareId/:tab',
    budgetProposalArgument:
        '/budget_proposal/:budgetProposalId/resource/:resourceSoftwareId/arguments/:argumentId',
    budgetProposalArgumentPdf:
        '/budget_proposal/:budgetProposalId/resource/:resourceSoftwareId/arguments/:argumentId/pdf',
    budgetProposalExpenseOrIncome:
        '/budget_proposal/:budgetProposalId/resource/:resourceSoftwareId/:expenseOrIncome/:viewBy',
    budgetProposalProjection:
        '/budget_proposal/:budgetProposalId/resource/:resourceSoftwareId/projection/:projectionType',
    budgetHome: BUDGET_HOME_PAGE_URL,
    budgetOverview: '/budget_overview/:tab/:expenseOrIncome?/:projectionType?',
    operationView:
        '/budget_operation_view/:operationSoftwareId/:expenseOrIncome',
    projectionsView: '/projections/:expenseOrIncome?',
    projectionsNoAccess: PROJECTIONS_NO_ACCESS_PAGE_URL,
    homePage: HOME_PAGE_URL,
    dashboards: `${DASHBOARDS_PAGE_URL}/:tab`,
    redirectDashboards: DASHBOARDS_PAGE_URL,
    indicators: '/indicators',
    decisionAdmin: DECISION_ADMIN_PAGE_URL,
    hrCta: `${HR_BASE_PATH_URL}/cta`,
    hrNoAccess: `${HR_BASE_PATH_URL}/no_access`,
    hrSimulationHome: `${HR_BASE_PATH_URL}/simulation_home`,
    hrSettings: `${HR_BASE_PATH_URL}/settings`,
    hrAnalyseMasseSalarialeHome: `${HR_BASE_PATH_URL}/analyse_masse_salariale_home`,
    hrAnalyseMasseSalarialeTab: `${HR_BASE_PATH_URL}/analyse_masse_salariale/:id/:tab`,
    hrAnalyseMasseSalariale: `${HR_BASE_PATH_URL}/analyse_masse_salariale/:id`,
    hrSimulationTab: `${HR_BASE_PATH_URL}/simulation/:id/:tab`,
    hrSimulation: `${HR_BASE_PATH_URL}/simulation/:id`,
    hrRetrospectiveHome: `${HR_BASE_PATH_URL}/retrospective_home`,
    hrRetrospective: `${HR_BASE_PATH_URL}/retrospective/:id`,
    ...datacatalogRoutes,
} as const;

export default routes;
